import styles from 'styles/admin-detail.module.scss';
import {
    INSURANCE_TYPE_MAPS,
} from 'const';

// 保険種別によって背景色を変える
const getStylesBackgroundColor = (insuranceType: string) => {
  if (insuranceType === INSURANCE_TYPE_MAPS['car']) {
    return (styles.insuranceTypeCarColor)
  }
  if (insuranceType === INSURANCE_TYPE_MAPS['fire']) {
    return (styles.insuranceTypeFireColor)
  }
  return (styles.insuranceTypeInjuryColor)
};

export default getStylesBackgroundColor;